// extracted by mini-css-extract-plugin
module.exports = {"Actualite":"actualite_Actualite__z7Kbq"};